import script from "./DownloadButtonWithLabel.vue?vue&type=script&setup=true&lang=js"
export * from "./DownloadButtonWithLabel.vue?vue&type=script&setup=true&lang=js"

import "./DownloadButtonWithLabel.vue?vue&type=style&index=0&id=e8cc1986&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8cc1986"]])

export default __exports__